import React, { useState } from "react";
import './index.css';

const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB in bytes

function App() {
  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Check if the file is an image
  const isImage = (file) => {
    return file && file.type.startsWith("image/");
  };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];

    // Check if file exists
    if (!selectedFile) return;

    // Check file size
    if (selectedFile.size > MAX_FILE_SIZE) {
      setErrorMessage("File is too large. Maximum size is 50 MB.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    // Upload the file to your backend or storage solution
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/upload`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.url) {
        setFile(selectedFile);
        setFileURL(data.url);
        setErrorMessage(""); // Clear any previous error messages
      } else {
        setErrorMessage("Failed to upload file.");
      }
    } catch (error) {
      setErrorMessage("Error uploading file.");
    }
  };

  return (
    <div className="App">
      <div className="upload-container">
        <h1>Upload a File</h1>
        <input
          type="file"
          onChange={handleFileChange}
        />
        {errorMessage && <p className="error">{errorMessage}</p>}
        {fileURL && isImage(file) && (
          <div>
            <p>Uploaded Image:</p>
            <img src={fileURL} alt={file.name} />
          </div>
        )}
        {fileURL && !isImage(file) && (
          <div>
            <p>File uploaded successfully! Here's your file URL:</p>
            <a href={fileURL} target="_blank" rel="noopener noreferrer">{fileURL}</a>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
